import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken, getUsuario } from '../services/auth';

export default function RequireAuth({ children, adminOnly }) {
  const token = getToken();
  const usuario = getUsuario();
  if (!token || !usuario) return <Navigate to="/login" />;
  if (adminOnly && usuario.tipo !== 'admin') return <Navigate to="/restrito" />;
  return children;
}
